<script>
import App from "@/pages/layouts/app.vue";
import Form from '@/pages/price_bundles/_form.vue';
import UpdateForm from "@wielink-application/shared/js/mixins/updateForm";

export default {
  mixins: [UpdateForm],
  components: {App, Form},
  props: ['price_bundle_id'],
  data() {
    return {
      formRoute: route('api.v1.price_bundles.update', {price_bundle: this.price_bundle_id}),
      redirectRoute: route('price_bundles.index'),
    }
  },
  methods: {
    afterSuccess(form, response) {
      this.getPriceBundle();
    },

    getPriceBundle() {
      this.loading = true;
      $.ajax({
        url: route('api.v1.price_bundles.show', {'price_bundle': this.price_bundle_id}),
        success: (response) => {
          this.$refs.form.setPriceBundle(response.data);
        }
      }).always(() => {
        this.loading = false;
      })
    }
  },
  mounted() {
    this.getPriceBundle();
  }
}
</script>

<template>
  <App title="Kortingsbundel bewerken">
    <form class="mb-4" id="priceBundleForm" @submit.prevent="submit">
      <Form ref="form"/>
    </form>

    <template #bottomButtons>
      <FormButtons
          @backToOverview="stayOnPage = 0"
          :loading="loading"
          form-id="priceBundleForm"
          :cancel-route="redirectRoute"
      />
    </template>
  </App>
</template>